import React from 'react';
import Modal from '@athena/spark/Modal';
import Button from '@athena/spark/Button';
import { useTranslation } from 'react-i18next';
import { contextConsentMap } from '../TermsOfUse';
import styles from './ConsentModal.module.scss';

type SupplementalConsentModalProps = {
  show: boolean;
  brandName?: string;
  contextId: number | string;
  onClose: (value: boolean) => void;
};

const ConsentModal: React.FC<SupplementalConsentModalProps> = ({ show, brandName, contextId, onClose }) => {
  const { t } = useTranslation();

  const buttons = [
    <Button
      data-testid="close-btn"
      className="fe_u_fill--width"
      key="0"
      size="large"
      onClick={() => onClose(false)}
      variant="outline"
    >
      <span>{t('LANDING_PAGE_TERMS_CLOSE')}</span>
    </Button>,
  ];

  return (
    <Modal
      aria-label={
        contextId === 'athenaTelehealth'
          ? t('LANDING_PAGE_TERMS_HEADING')
          : t('LANDING_PAGE_CONSENT_HEADING', { brandName })
      }
      show={show}
      header={
        contextId === 'athenaTelehealth'
          ? t('LANDING_PAGE_TERMS_HEADING')
          : t('LANDING_PAGE_CONSENT_HEADING', { brandName })
      }
      onHide={() => onClose(false)}
      buttons={buttons}
      width="large"
      className={styles.termsModal}
    >
      {contextConsentMap[contextId]()}
    </Modal>
  );
};

export default ConsentModal;
